// extracted by mini-css-extract-plugin
export var currencyInput = "_j2-1";
export var currencySymbol = "_j2-0";